import { useDark, usePreferredColorScheme } from '@vueuse/core';

const userColorScheme = usePreferredColorScheme();
export const toggleColor = useDark(userColorScheme);
